import { Cell, XFlowGraph, useGraphEvent, useGraphInstance } from "@antv/xflow"
import { forwardRef, useEffect, useImperativeHandle } from "react"
import { resetTempCells } from "./services/resetCells"
import { Arrowhead } from "./events/useEdgeEvents"
import { useEditorEvents } from "./events/useEditorEvents"

interface EditorGraphProps {
  onSelected?: (params: any) => void
  content: Cell.Properties[]
  onChange?: () => void
}

export const TempGraph = forwardRef((props: EditorGraphProps, ref) => {
  const {onSelected, content} = props
  const graph = useGraphInstance()
  useEditorEvents(false, true)
  useGraphEvent<any>('cell:click', (params) => {
    onSelected?.(params)
  })

   useGraphEvent('edge:selected', ({ edge }) => {
    edge.addTools([
      'segments',
      {
        name: 'vertices',
        args: {
          addable: true,
          removable: false,
          stopPropagation: false
        }
      },
      {
        name: 'source-arrowhead',
        args: Arrowhead
      },
      {
        name: 'target-arrowhead',
        args: Arrowhead
      }
    ])
  })

  useGraphEvent('edge:unselected', ({ edge }) => {
    edge.removeTools()
  })

  useImperativeHandle(
    ref,
    () => ({
      getGraph: () => graph
    }),
    [graph]
  )

  useEffect(() => {
    if (graph) {
      resetTempCells(content || [], graph, true)
    }
  }, [content, graph])

  useEffect(() => {
    // for test
    if (!graph) return;
    (window as any).__x6_instances__ = [];
    (window as any).__x6_instances__.push(graph)
  }, [graph])

  return <>
    <XFlowGraph
      scroller
      zoomable
      pannable
      minScale={0.5}
      maxScale={2}
      
      connectionOptions={{
        router: 'normal',
        connectionPoint: 'anchor',
        allowBlank: true,
        allowMulti: false,
        allowLoop: false,
        allowNode: false,
        allowEdge: false,
        allowPort: true,
      }}
      zoomOptions={{
        global: true,
        modifiers: ['ctrl', 'meta'],
      }} />
  </>
});